import React from 'react';

export default function ConfirmCard({ data, onRespond }) {
  return (
    <>
      {data.title && <div className="ws-card__title">{data.title}</div>}

      <div className="ws-card-fields">
        {data.fields?.map((field, index) => (
          <div key={field.key || index} className="ws-card-field">
            <span className="ws-card-field__label">{field.label}</span>
            <span className="ws-card-field__value">{field.value}</span>
          </div>
        ))}
      </div>

      {!data.answered && (
        <div className="ws-card-actions">
          <button
            className="ws-card-btn ws-card-btn--primary"
            onClick={() => onRespond(data.id, 'confirm')}
            type="button"
          >
            Bevestig
          </button>
          <button
            className="ws-card-btn"
            onClick={() => onRespond(data.id, 'edit')}
            type="button"
          >
            Aanpassen
          </button>
        </div>
      )}
    </>
  );
}
